<template>
  <div class="inner-container">
    <h1 class="font-title mt-12 mb-6">
eGift Cards
</h1>

    <div class="divider mb-12" />

    <div class="grid">
      <gift-button-card
        title="Give a Perfect Gift"
        btn-text="BUY eGIFT CARD"
        :img-src="giftCardImage.url"
        :img-alt="giftCardImage.alt ? giftCardImage.alt : 'Gift Card'"
        :rounded="true"
        css-class="keepCase"
        @btnClick="onBuy()"
      />

      <gift-button-card
        title="Already Have an eGift Card?"
        btn-text="Check Balance"
        :img-src="alreadyHaveImage.url"
        :img-alt="alreadyHaveImage.alt ? alreadyHaveImage.alt : 'Already have gift card'"
        @btnClick="onCheckBalance()"
      />
    </div>
  </div>
</template>

<script>
import prismicApi from "~/helpers/prismic-api"
import giftButtonCard from "~/components/pages/gift-card/home/gift-button-card.vue"

export default {
  components: { giftButtonCard },
  name: "GiftCardHome",
  data: () => ({
    giftCardImage: {
      url: '',
      alt: ''
    },
    alreadyHaveImage: {
      url: '',
      alt: ''
    }
  }),
  methods: {
    onCheckBalance () {
      this.$nuxt.$options.router.push("/gift-cards/check-balance")
    },
    onBuy () {
      this.$nuxt.$options.router.push("/gift-cards/buy/single")
    }
  },
  async asyncData () {
    const uid = 'gift_card_config'
    const result = await prismicApi.getByUID('gift_card_config', uid)
    const alreadyHaveImage = {
      url: result.document.already_have_a_gift_card_image.url,
      alt: result.document.already_have_a_gift_card_image.alt
    }
    const giftCardImage = {
      url: result.document.gift_card_image.url,
      alt: result.document.gift_card_image.alt
    }

    return {
      alreadyHaveImage,
      giftCardImage
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./scss/variables";
.inner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.divider {
  width: 500px;
  max-width: 100%;
  height: 1px;
  background-color: $light-grey;
}

.grid {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 100%;
}
</style>
